import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getLoyalty = createAsyncThunk('overview/getLoyalty', async () => {
	return await AccountService.loyalty();
});
